import { FC, useEffect } from "react";
import { Trans } from "@lingui/macro";
import { Box, Button, Text } from "@otrium/design";
import { useSegment } from "src/hooks/useSegment";
import styles from "./_error.module.scss";

interface Props {
  href?: string;
  text?: JSX.Element;
  title?: JSX.Element | string;
}

const Error: FC<Props> = ({ href = "/", text, title }) => {
  const { segmentTrackingError } = useSegment();

  useEffect(() => {
    void segmentTrackingError({
      error_type: "status",
      error_message: "Page not found",
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className={styles.container}>
      <Text variant="h2" as="h1">
        {title ? title : <Trans>{"We're sorry"}</Trans>}
      </Text>
      <Text className={styles.description} data-testid="error-page-description">
        {text ? (
          text
        ) : (
          <>
            <Trans>It looks like something went wrong our side.</Trans>
            <br />
            <Trans>
              We’re trying to fix this right now so please try back later. In
              the meantime you can continue shopping.
            </Trans>
          </>
        )}
      </Text>
      <Box mt={{ xs: "16", md: "24" }}>
        <Button href={href} data-testid="error-page-url">
          <Trans>Continue shopping</Trans>
        </Button>
      </Box>
    </div>
  );
};

export default Error;
